<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import RoleForm from './RoleForm.vue';

const { t } = useI18n();
const store = useStore();
const route = useRoute();
const router = useRouter();

const uiFlags = useMapGetter('customRoles/getUIFlags');
const records = useMapGetter('customRoles/getCustomRoles');
const currentAccountId = useMapGetter('getCurrentAccountId');

const roleId = computed(() => Number(route.params.roleId));
const role = computed(
  () => records.value.find(r => r.id === roleId.value) || {}
);

onMounted(async () => {
  if (!records.value.length) {
    await store.dispatch('customRoles/get');
  }
  if (!records.value.find(r => r.id === roleId.value)) {
    await store.dispatch('customRoles/show', roleId.value);
  }
});

const goToList = () => {
  router.push({
    name: 'custom_roles_list',
    params: { accountId: currentAccountId.value },
  });
};

const onSubmit = async payload => {
  try {
    await store.dispatch('customRoles/update', {
      id: roleId.value,
      ...payload,
    });
    useAlert(t('SETTINGS.CUSTOM_ROLES.EDIT.API.SUCCESS_MESSAGE'));
    goToList();
  } catch (error) {
    useAlert(
      error?.message || t('SETTINGS.CUSTOM_ROLES.EDIT.API.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="t('SETTINGS.CUSTOM_ROLES.EDIT.TITLE')"
        :description="t('SETTINGS.CUSTOM_ROLES.EDIT.DESC')"
      />
    </template>
    <template #body>
      <div class="max-w-3xl">
        <RoleForm
          :role="role"
          :submit-label="t('SETTINGS.CUSTOM_ROLES.EDIT.SUBMIT')"
          :is-submitting="uiFlags.isUpdating"
          @submit="onSubmit"
          @cancel="goToList"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
